import React, { useContext } from 'react'
import { AppStateContext } from '../layouts/layout'

import { useI18next } from 'gatsby-plugin-react-i18next'
import Icons from '../components/Icons'

const LangSwitcher = (props) => {
  const {language, changeLanguage} = useI18next()

  const [appState, setAppState] = useContext(AppStateContext)

  const handleChange = () => {
    if (language === 'en') {
      setAppState({ ...appState, lang: 'fr' })
      changeLanguage('fr')
    } else {
      setAppState({ ...appState, lang: 'en' })
      changeLanguage('en')
    }
  }

  return (
    <div {...props} className="flex md:flex-col md:items-center justify-center md:mt-7">
      <Icons name="united-kingdom" className="h-5 md:mx-auto mb-5" />
      <button
        type="button"
        onClick={() => handleChange()}
        className={`${
          appState.lang === 'fr' ? 'bg-royal-blue' : 'bg-athens-gray'
        } relative md:rotate-90 md:transform inline-flex flex-shrink-0 mx-2 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none`}
        aria-pressed="false"
      >
        <span
          aria-hidden="true"
          className={`${
            appState.lang === 'fr' ? 'translate-x-5 bg-athens-gray' : 'translate-x-0 bg-martinique'
          } pointer-events-none inline-block h-5 w-5 rounded-full shadow transform ring-0 transition ease-in-out duration-200`}
        ></span>
      </button>
      <Icons name="france" className="h-5 md:mx-auto md:mt-5"/>
    </div>
  )
}

export default LangSwitcher
